import { useEffect, memo } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import service from '../../../services';
import { useLaunchPayload, useRequestLoginModal } from './hooks';

const GameLaunchReviewMode = memo(() => {
  const { gameId } = useParams();
  const [launchPayload, isReady] = useLaunchPayload(gameId);
  const { goBack } = useHistory();

  // if user is not authorized - request login screen
  useRequestLoginModal();

  useEffect(() => {
    if (launchPayload) {
      // TODO: use action from corefront/redux-aba package
      service.publish('event', 'game:launch', launchPayload);
    }

    /**
     * waiting for resolved launch payload - successful or not
     * and only after that - redirect to previous page
     */
    if (isReady) {
      goBack();
    }
  }, [launchPayload, isReady, goBack]);

  return null;
});

export default GameLaunchReviewMode;
